export const TARGETS = {
  EVENTS: 'events'
};

export const DEFAULT_STATE = {
  events: []
};
